<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Configuração operacional</span>
        <h1>Editar operação</h1>
        <p>Atualize os dados da operação e configure a integração via SFTP.</p>
      </div>
    </header>

    <div class="row">
      <div class="col-xxl-12">
        <FormUpdateOperation />
      </div>
      <div class="col-xxl-12">
        <UpdateConfigurationsSftp />
      </div>
    </div>
  </div>
</template>

<script lang="ts"> 
import { defineComponent } from "vue";

import FormUpdateOperation from "../../components/Configurations/FormUpdateOperation.vue";
import UpdateConfigurationsSftp from "../../components/Configurations/UpdateConfigurationsSftp.vue";

export default defineComponent({
  name: "OperationPage",
  components: {
    UpdateConfigurationsSftp,
    FormUpdateOperation
  }
});
</script>
